var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBottomMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74796 9.79614L8.03996 10.5041L12 14.4641L15.96 10.5041L15.252 9.79614L12 13.0481L8.74796 9.79614Z",
    fill: "#007BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottomMedium);
export default __webpack_public_path__ + "static/media/arrow-bottom-medium.55c6926cc01b0c1a523c66f4061bb020.svg";
export { ForwardRef as ReactComponent };